import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const MHModalSymtoms = (props)=>{
    const multiSelectRef = useRef(null);
    
    const symptoms_options = [
        { "label": "Depression", "value": "Depression" },
        { "label": "Kidney stones", "value": "Kidney stones" },
        { "label": "Abnormal heart rhythm", "value": "Abnormal heart rhythm" },
        { "label": "Diabetes", "value": "Diabetes" },
        { "label": "Memory problems", "value": "Memory problems" },
        { "label": "Anxiety", "value": "Anxiety" },
        { "label": "Drug or alcohol dependency", "value": "Drug or alcohol dependency" },
        { "label": "Poor hearing", "value": "Poor hearing" },
        { "label": "Other", "value": "Other" }
    ];
    const [symptoms_selected, setSymptoms_selected] = useState([]);
    useEffect(()=>{
        setTimeout(()=>{
            document.querySelectorAll('.nex-symptoms-sdrops-w .rmsc .dropdown-heading')[0].click();
        }, 800);
        
    }, [props.modal]);

    const closePopup = ()=>{
        document.querySelectorAll('.so_mh_modal_popup .modal-header .close')[0].click();
    }

    return (
<Modal isOpen={props.modal} toggle={props.toggle} {...props} className="so_mh_modal_popup">
        <ModalHeader toggle={props.toggle}>Symptoms</ModalHeader>
        <ModalBody>
          <div className="nex-modal-select-drops-wrap nex-symptoms-sdrops-w" ref={multiSelectRef} >
          
                <MultiSelect
                    
                    options={symptoms_options}
                    value={symptoms_selected}
                    onChange={setSymptoms_selected}
                    labelledBy="Select"
                />
          </div>
          <div className="nex-modal-actions mt-3 mb-2 d-flex justify-content-end">
                <a href="#" className="nexogic_primary_button" onClick={(e)=>{closePopup(); props.goto(e, 6);}}>Add</a>
          </div>
        </ModalBody>
        
</Modal>
    )
}
export default MHModalSymtoms;